import NationalHealthServiceBP from "./NationalHealthServiceBP";

export default {
    NationalHealthServiceBP
};
